export const toggleOverflow = (shouldDisable) => {
    document.body.classList.toggle('no-scroll', shouldDisable);
}